var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},_vm._l((_vm.listArr),function(item,index){return _c('div',{key:index,staticClass:"Service-body firm-clickable",on:{"click":function($event){return _vm.handelComeAndHelp(item)}}},[(_vm.distinguish==1)?_c('div',{staticClass:"Select-box"},[_c('el-checkbox',{model:{value:(item.choose),callback:function ($$v) {_vm.$set(item, "choose", $$v)},expression:"item.choose"}})],1):_vm._e(),_c('div',{staticClass:"status-show",class:item.status == '0'
          ? 'CallForBids'
          : item.status == '1'
          ? 'proceed'
          : item.status == '2'
          ? 'examine'
          : item.status == '3'
          ? 'Lose'
          : item.status == '4'
          ? 'delist'
          : item.status == '5'
          ? 'complete'
          : ''}),_c('p',{staticClass:"requirement"},[_vm._v("本公司需要logo设计")]),_c('p',{staticClass:"Price"},[_vm._v("￥ 2000")]),_c('p',{staticClass:"type"},[_vm._v("需求类型：LOGO设计")]),_c('p',{staticClass:"Description-title"},[_vm._v("需求描述：")]),_c('p',{staticClass:"Description"},[_vm._v(" 国际物流行业，需求轻微修改logo中英文字体设计，目前原有logo寓意是国际物流面向全球运输yc字母组成环绕地 ")]),_c('div',{staticClass:"bottom"},[_c('p',[_vm._v("2024年12月12日发布")]),(_vm.distinguish==1)?_c('div'):_vm._e()])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }